var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"screen",attrs:{"title":"Frequently Asked Questions"}},[_c('f-a-q-section',{attrs:{"headers":"","faqs":_vm.faqs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }